<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Monitor from "@/services/Monitor";
import Football from "@/services/Football";
import ModalAddSportCompetition from "@/components/modals/monitor/ModalAddSportCompetition";
import ModalAddSportTournament from "@/components/modals/monitor/ModalAddSportTournament";
import ModalAddSportStage from "@/components/modals/monitor/ModalAddSportStage";
import ModalEditSportDataCompetition from "@/components/modals/monitor/ModalEditSportDataCompetition";

const PROVIDER = "Azerion";

export default {
  components: {
    Layout,
    PageHeader,
    ModalAddSportCompetition,
    ModalAddSportTournament,
    ModalAddSportStage,
    ModalEditSportDataCompetition,
  },
  page: {
    title: "Sport Data Setup",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Sport Data Setup",
      provider: PROVIDER,
      items: [
        { text: "Sport Data" },
        { text: "Sport Data Setup", active: true },
      ],
      sportCompetitionData: null,

      compIsBusy: false,
      compTableData: [],
      compTotalRows: 0,
      compCurrentPage: 1,
      compPerPage: 10,
      compPageOptions: [10, 25, 50, 100],
      compFilter: null,
      compFilterOn: ["competition_name", "competition_code", "competition_country"],
      compSortBy: "competition_name",
      compSortDesc: false,
      compFilterData: false,
      compFields: [
        { key: "competition_name", label: "Competition Name", sortable: true },
        { key: "competition_code", label: "Competition Code", sortable: true },
        { key: "competition_country", label: "Country", sortable: true },
        { key: "competition_type", label: "Type", sortable: true },
        { key: "competition_logo", label: "Logo", sortable: false },
        { key: "provider", label: "Provider", sortable: true },
        "action",
      ],

      tourIsBusy: false,
      tourTableData: [],
      tourTotalRows: 0,
      tourCurrentPage: 1,
      tourPerPage: 10,
      tourPageOptions: [10, 25, 50, 100],
      tourFilter: null,
      tourFilterOn: ["tournament_name", "tournament_season", "competition_name"],
      tourSortBy: "tournament_season",
      tourSortDesc: true,
      tourFilterData: false,
      tourFields: [
        { key: "tournament_name", label: "Tournament Name", sortable: true },
        { key: "tournament_season", label: "Season", sortable: true },
        { key: "competition_name", label: "Competition", sortable: true },
        { key: "tournament_start", label: "Start", sortable: true },
        { key: "tournament_end", label: "End", sortable: true },
        { key: "provider", label: "Provider", sortable: true },
      ],

      stageIsBusy: false,
      stageTableData: [],
      stageTotalRows: 0,
      stageCurrentPage: 1,
      stagePerPage: 10,
      stagePageOptions: [10, 25, 50, 100],
      stageFilter: null,
      stageFilterOn: ["stage_name", "tournament_id", "tournament_name"],
      stageSortBy: "stage_name",
      stageSortDesc: false,
      stageFilterData: false,
      stageFields: [
        { key: "stage_name", label: "Stage Name", sortable: true },
        { key: "tournament_name", label: "Tournament", sortable: true },
        { key: "stage_start", label: "Start", sortable: true },
        { key: "stage_end", label: "End", sortable: true },
        { key: "provider", label: "Provider", sortable: true },
      ],

      error: null,
    };
  },
  mounted() {
    this.loadAllData();
  },
  methods: {
    providerQuery() {
      return `provider=${encodeURIComponent(this.provider)}`;
    },

    onCompFiltered(filteredItems) {
      this.compTotalRows = filteredItems.length;
      this.compCurrentPage = 1;
    },
    onTourFiltered(filteredItems) {
      this.tourTotalRows = filteredItems.length;
      this.tourCurrentPage = 1;
    },
    onStageFiltered(filteredItems) {
      this.stageTotalRows = filteredItems.length;
      this.stageCurrentPage = 1;
    },

    toggleCompBusy() {
      this.compIsBusy = !this.compIsBusy;
    },
    toggleTourBusy() {
      this.tourIsBusy = !this.tourIsBusy;
    },
    toggleStageBusy() {
      this.stageIsBusy = !this.stageIsBusy;
    },

    async loadAllData() {
      await this.getSportCompetitions();
      await this.getSportTournaments();
      await this.getSportStages();
    },

    async getSportCompetitions() {
      try {
        this.toggleCompBusy();
        const response = await Monitor.getSportCompetitions(this.providerQuery());
        this.compTableData = response.data.data || [];
        this.compTotalRows = this.compTableData.length;
        this.compCurrentPage = 1;
        this.compFilterData = true;
      } catch (error) {
        this.error = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : "";
        this.compTableData = [];
        this.compTotalRows = 0;
        this.compCurrentPage = 1;
        this.compFilterData = true;
      } finally {
        this.toggleCompBusy();
      }
    },

    async getSportTournaments() {
      try {
        this.toggleTourBusy();
        const response = await Football.getSportTournaments(this.providerQuery());
        this.tourTableData = response.data.data || [];
        this.tourTotalRows = this.tourTableData.length;
        this.tourCurrentPage = 1;
        this.tourFilterData = true;
      } catch (error) {
        this.error = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : "";
        this.tourTableData = [];
        this.tourTotalRows = 0;
        this.tourCurrentPage = 1;
        this.tourFilterData = true;
      } finally {
        this.toggleTourBusy();
      }
    },

    async getSportStages() {
      try {
        this.toggleStageBusy();
        const response = await Monitor.getSportStages(this.providerQuery());
        const stages = response.data.data || [];
        const tournamentMap = {};
        this.tourTableData.forEach((t) => {
          tournamentMap[t.tournament_id] = t;
        });
        this.stageTableData = stages.map((stage) => {
          const tournament = tournamentMap[stage.tournament_id] || {};
          return Object.assign({}, stage, {
            tournament_name: tournament.tournament_name || "",
          });
        });
        this.stageTotalRows = this.stageTableData.length;
        this.stageCurrentPage = 1;
        this.stageFilterData = true;
      } catch (error) {
        this.error = error.response && error.response.data && error.response.data.error
          ? error.response.data.error
          : "";
        this.stageTableData = [];
        this.stageTotalRows = 0;
        this.stageCurrentPage = 1;
        this.stageFilterData = true;
      } finally {
        this.toggleStageBusy();
      }
    },

    async refreshStages() {
      if (!this.tourTableData.length) {
        await this.getSportTournaments();
      }
      await this.getSportStages();
    },

    openAddCompetition() {
      this.$bvModal.show("add_sport_competition");
    },
    openAddTournament() {
      this.$bvModal.show("add_sport_tournament");
    },
    openAddStage() {
      this.$bvModal.show("add_sport_stage");
    },
    openEditCompetition(item) {
      this.sportCompetitionData = item;
      this.$bvModal.show("edit_sport_data_competition");
    },
  },
  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row g-3">
      <!-- Competitions -->
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
              <h4 class="card-title m-0 d-flex align-items-center">
                <i class="mdi mdi-trophy-outline me-2 text-success"></i>
                Competitions
                <span class="badge bg-light text-dark ms-2 fw-normal">{{ provider }}</span>
                <span v-if="compFilterData" class="badge bg-success-subtle text-success ms-2 fw-normal">{{ compTotalRows }} total</span>
              </h4>
              <a
                href="javascript:void(0);"
                class="btn btn-success waves-effect waves-light"
                @click="openAddCompetition"
              >
                <i class="mdi mdi-plus me-2"></i>
                Add Competition
              </a>
            </div>

            <div class="row mt-4" v-show="compFilterData">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="compPerPage" size="sm" :options="compPageOptions"></b-form-select>
                    &nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <div class="search-box-wrapper d-inline-flex align-items-end">
                    <i class="mdi mdi-magnify search-icon"></i>
                    <b-form-input
                      v-model="compFilter"
                      type="search"
                      placeholder="Search competitions..."
                      class="form-control form-control-sm search-input"
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0 mt-2">
              <b-table
                :items="compTableData"
                :busy="compIsBusy"
                :fields="compFields"
                responsive="sm"
                hover
                :per-page="compPerPage"
                :current-page="compCurrentPage"
                :sort-by.sync="compSortBy"
                :sort-desc.sync="compSortDesc"
                :filter="compFilter"
                :filter-included-fields="compFilterOn"
                @filtered="onCompFiltered"
                show-empty
                empty-text="No Data Found"
              >
                <template v-slot:cell(competition_logo)="data">
                  <img
                    v-if="data.item.competition_logo"
                    :src="data.item.competition_logo"
                    alt="Competition Logo"
                    style="width: 80px; background: #F5F6F8;"
                  />
                </template>
                <template v-slot:cell(action)="data">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <a
                        href="javascript:void(0);"
                        class="px-2 text-primary"
                            title="Edit"
                            @click="openEditCompetition(data.item)"
                      >
                        <i class="uil uil-pen font-size-18"></i>
                      </a>
                    </li>
                  </ul>
                </template>
                <template #table-busy>
                  <div class="text-center my-4">
                    <b-spinner variant="primary" class="align-middle"></b-spinner>
                    <strong class="ms-2">Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row" v-show="compFilterData">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="compCurrentPage"
                      :total-rows="compTotalRows"
                      :per-page="compPerPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tournaments -->
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
              <h4 class="card-title m-0 d-flex align-items-center">
                <i class="mdi mdi-trophy-variant-outline me-2 text-success"></i>
                Tournaments
                <span class="badge bg-light text-dark ms-2 fw-normal">{{ provider }}</span>
                <span v-if="tourFilterData" class="badge bg-success-subtle text-success ms-2 fw-normal">{{ tourTotalRows }} total</span>
              </h4>
              <a
                href="javascript:void(0);"
                class="btn btn-success waves-effect waves-light"
                @click="openAddTournament"
              >
                <i class="mdi mdi-plus me-2"></i>
                Add Tournament
              </a>
            </div>

            <div class="row mt-4" v-show="tourFilterData">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="tourPerPage" size="sm" :options="tourPageOptions"></b-form-select>
                    &nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <div class="search-box-wrapper d-inline-flex align-items-end">
                    <i class="mdi mdi-magnify search-icon"></i>
                    <b-form-input
                      v-model="tourFilter"
                      type="search"
                      placeholder="Search tournaments..."
                      class="form-control form-control-sm search-input"
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0 mt-2">
              <b-table
                :items="tourTableData"
                :busy="tourIsBusy"
                :fields="tourFields"
                responsive="sm"
                hover
                :per-page="tourPerPage"
                :current-page="tourCurrentPage"
                :sort-by.sync="tourSortBy"
                :sort-desc.sync="tourSortDesc"
                :filter="tourFilter"
                :filter-included-fields="tourFilterOn"
                @filtered="onTourFiltered"
                show-empty
                empty-text="No Data Found"
              >
                <template #table-busy>
                  <div class="text-center my-4">
                    <b-spinner variant="primary" class="align-middle"></b-spinner>
                    <strong class="ms-2">Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row" v-show="tourFilterData">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="tourCurrentPage"
                      :total-rows="tourTotalRows"
                      :per-page="tourPerPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Stages -->
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
              <h4 class="card-title m-0 d-flex align-items-center">
                <i class="mdi mdi-layers-outline me-2 text-success"></i>
                Stages
                <span class="badge bg-light text-dark ms-2 fw-normal">{{ provider }}</span>
                <span v-if="stageFilterData" class="badge bg-success-subtle text-success ms-2 fw-normal">{{ stageTotalRows }} total</span>
              </h4>
              <a
                href="javascript:void(0);"
                class="btn btn-success waves-effect waves-light"
                @click="openAddStage"
              >
                <i class="mdi mdi-plus me-2"></i>
                Add Stage
              </a>
            </div>

            <div class="row mt-4" v-show="stageFilterData">
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="stagePerPage" size="sm" :options="stagePageOptions"></b-form-select>
                    &nbsp;entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_filter text-md-end">
                  <div class="search-box-wrapper d-inline-flex align-items-end">
                    <i class="mdi mdi-magnify search-icon"></i>
                    <b-form-input
                      v-model="stageFilter"
                      type="search"
                      placeholder="Search stages..."
                      class="form-control form-control-sm search-input"
                    ></b-form-input>
                  </div>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0 mt-2">
              <b-table
                :items="stageTableData"
                :busy="stageIsBusy"
                :fields="stageFields"
                responsive="sm"
                hover
                :per-page="stagePerPage"
                :current-page="stageCurrentPage"
                :sort-by.sync="stageSortBy"
                :sort-desc.sync="stageSortDesc"
                :filter="stageFilter"
                :filter-included-fields="stageFilterOn"
                @filtered="onStageFiltered"
                show-empty
                empty-text="No Data Found"
              >
                <template #table-busy>
                  <div class="text-center my-4">
                    <b-spinner variant="primary" class="align-middle"></b-spinner>
                    <strong class="ms-2">Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row" v-show="stageFilterData">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="stageCurrentPage"
                      :total-rows="stageTotalRows"
                      :per-page="stagePerPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ModalAddSportCompetition :provider="provider" @onRefresh="getSportCompetitions" />
    <ModalAddSportTournament
      :competition-options="compTableData"
      :provider="provider"
      @onRefresh="getSportTournaments"
    />
    <ModalAddSportStage
      :tournament-options="tourTableData"
      :provider="provider"
      @onRefresh="refreshStages"
    />
    <ModalEditSportDataCompetition
      :competition-details="sportCompetitionData"
      :provider="provider"
      @onRefresh="getSportCompetitions"
    />
  </Layout>
</template>

<style scoped>
.search-box-wrapper {
  position: relative;
}
.search-icon {
  position: absolute;
  left: 10px;
  color: #b3b7bd;
  font-size: 16px;
  pointer-events: none;
}
.search-input {
  padding-left: 30px;
  min-width: 220px;
}
</style>
